// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/" + chunkId + "." + chunkId + "." + {"2530": "e96a97f91d26","4004": "66f2b799903c","5049": "0de64869a981","6863": "454c9f289029","8270": "72223c79a1b1","8357": "dd422574e14d",}[chunkId] + ".css"
}